<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  isConfirmLoading?: boolean;
  errorMessage?: string;
  retryCallback?: () => Promise<void>;
  cancelCallback?: () => Promise<void>;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  errorMessage: 'An error occurred while saving',
  retryCallback: undefined,
  cancelCallback: undefined,
});

const emit = defineEmits<{
  cancelBtnClick: [event: Event, props: DefProps];
  closeBtnClick: [event: Event];
  tryAgainBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event, props);
}

function handleCloseClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('closeBtnClick', event);
}

function handleTryAgainClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('tryAgainBtnClick', event, props);
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditErrorDialog, dialog.dialogRoot]"
    data-testid="jobEditErrorDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader :show-close-btn="false">
        Error Saving Job
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="dialog.text">
        {{ props.errorMessage }}
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :disabled="props.isConfirmLoading"
            @click="handleCancelClick"
          >
            Cancel
          </KBtn>
        </li>
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close-circle"
            :disabled="props.isConfirmLoading"
            @click="handleCloseClick"
          >
            Close
          </KBtn>
        </li>
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            append-icon="mdi-reload"
            :loading="props.isConfirmLoading"
            @click="handleTryAgainClick"
          >
            Try Again
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
.jobEditErrorDialog {
}
</style>
